import React, { useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import PsychologyIcon from '@mui/icons-material/Psychology';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import GPAI from '../../../components/ModelTestingDoctor/GPAI';
import DAI from '../../../components/ModelTestingDoctor/DAI';
import Header from 'components/Header';
const menuItems = [
  { key: 'DAI', label: 'DAI', icon: <PsychologyIcon /> },
  { key: 'GPAI', label: 'GPAI', icon: <SmartToyIcon /> },
];

const ModalTestingPage: React.FC = () => {
  const [selected, setSelected] = useState('DAI');

  const renderContent = () => {
    switch (selected) {
      case 'DAI':
        return <DAI />;
      case 'GPAI':
        return <GPAI />;
      default:
        return null;
    }
  };

  return (
    <div>
      <Header />
      <Box sx={{ paddingTop: '150px', px: 5 }}>
        {/* Horizontal Menu */}
        <Stack direction="row" spacing={10} sx={{ position: 'relative', borderBottom: '1px solid rgba(0,0,0,0.3)' }}>
          {menuItems.map(item => (
            <Box
              key={item.key}
              sx={{
                cursor: 'pointer',
                position: 'relative',
                bottom: '-1px',
                borderBottom: selected === item.key ? '3px solid #9747FF' : '3px solid transparent',
                pb: '6px',
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 400,
                fontSize: '25px',
                px: 2,
                color: 'rgba(2, 7, 66, 0.6)',
              }}
              onClick={() => setSelected(item.key)}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                {item.icon}
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontWeight: 400,
                    fontSize: '25px !important',
                    color: selected === item.key ? 'rgba(2, 7, 66, 1)' : 'rgba(2, 7, 66, 0.6)',
                  }}
                >
                  {item.label}
                </Typography>
              </Stack>
            </Box>
          ))}
        </Stack>

        {/* Rendered Content */}
        <Box mt={4}>{renderContent()}</Box>
      </Box>
    </div>
  );
};

export default ModalTestingPage;
